<template>
  <div>
    <!-- 个人详细信息部分 -->
    <div class="personal-details-section">
      <div class="section-header">
        <h3 class="section-title">个人详细信息</h3>
        <div class="header-buttons">
          <el-button 
            v-if="isEditing" 
            type="default" 
            class="cancel-btn" 
            @click="cancelEdit"
          >
            <!-- <img src="./assets/img/cancel.png" class="btn-icon" /> -->
            取消编辑
          </el-button>
          <el-button type="primary" class="edit-btn" @click="toggleEditMode">
            <img src="./assets/img/edit.png" class="btn-icon" />
            {{ isEditing ? '保存' : '编辑个人信息' }}
          </el-button>
        </div>
      </div>
      
      <div class="details-content">
        <div class="details-left">
          <div class="detail-item">
            <span class="detail-label">姓名:</span>
            <input 
              v-if="isEditing" 
              v-model="personalInfo.name" 
              class="detail-input"
              placeholder="请输入姓名"
            />
            <span 
              v-else 
              class="detail-value"
            >
              {{ personalInfo.name || '未设置' }}
            </span>
          </div>
          <div class="detail-item">
            <span class="detail-label">年龄:</span>
            <input 
              v-if="isEditing" 
              v-model="personalInfo.age" 
              class="detail-input"
              placeholder="请输入年龄"
            />
            <span 
              v-else 
              class="detail-value"
            >
              {{ personalInfo.age || '未设置' }}
            </span>
          </div>
          <div class="detail-item">
            <span class="detail-label">电话:</span>
            <input 
              v-if="isEditing" 
              v-model="personalInfo.phone" 
              class="detail-input"
              placeholder="请输入电话"
            />
            <span 
              v-else 
              class="detail-value"
            >
              {{ personalInfo.phone || '未设置' }}
            </span>
          </div>
          <div class="detail-item">
            <span class="detail-label">邮箱:</span>
            <input 
              v-if="isEditing" 
              v-model="personalInfo.email" 
              class="detail-input"
              placeholder="请输入邮箱"
            />
            <span 
              v-else 
              class="detail-value"
            >
              {{ personalInfo.email || '未设置' }}
            </span>
          </div>
        </div>
        
        <div class="details-right">
          <div class="detail-item">
            <span class="detail-label">性别:</span>
            <select 
              v-if="isEditing" 
              v-model="personalInfo.gender" 
              class="detail-select"
            >
              <option value="男">男</option>
              <option value="女">女</option>
            </select>
            <span 
              v-else 
              class="detail-value"
            >
              {{ personalInfo.gender || '未设置' }}
            </span>
          </div>
          <div class="detail-item">
            <span class="detail-label">最高学历:</span>
            <select 
              v-if="isEditing" 
              v-model="personalInfo.education" 
              class="detail-select"
            >
              <option value="2">高中</option>
              <option value="3">专科</option>
              <option value="4">本科</option>
              <option value="5">硕士</option>
              <option value="6">博士</option>
            </select>
            <span 
              v-else 
              class="detail-value"
            >
              {{ getEducationText(personalInfo.education) }}
            </span>
          </div>
          <div class="detail-item">
            <span class="detail-label">最高学历院校:</span>
            <input 
              v-if="isEditing" 
              v-model="personalInfo.school" 
              class="detail-input"
              placeholder="请输入学校"
            />
            <span 
              v-else 
              class="detail-value"
            >
              {{ personalInfo.school || '未设置' }}
            </span>
          </div>
          <div class="detail-item">
            <span class="detail-label">专业:</span>
            <input 
              v-if="isEditing" 
              v-model="personalInfo.major" 
              class="detail-input"
              placeholder="请输入专业"
            />
            <span 
              v-else 
              class="detail-value"
            >
              {{ personalInfo.major || '未设置' }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- 求职期望部分 -->
    <div class="job-expectations-section">
      <div class="section-header">
        <h3 class="section-title">求职期望</h3>
        <el-button type="primary" class="add-btn" @click="addJobExpectation">
          <img src="./assets/img/add.png" class="btn-icon" />
          添加求职期望
        </el-button>
      </div>
      
      <div class="expectations-content">
        <div 
          v-for="(expectation, index) in jobExpectations" 
          :key="index" 
          class="expectation-card"
        >
          <div class="expectation-info">
            <div class="expectation-item">
              <span class="expectation-label">求职类型:</span>
              <span class="expectation-value">{{ getJobTypeLabel(expectation.job_type) }}</span>
            </div>
            <div class="expectation-item">
              <span class="expectation-label">期望职位:</span>
              <span class="expectation-value" :title="expectation.job_objective">{{ expectation.job_objective }}</span>
            </div>
            <div class="expectation-item">
              <span class="expectation-label">工作地点:</span>
              <span class="expectation-value">{{ expectation.desired_city }}</span>
            </div>
            <div class="expectation-item">
              <span class="expectation-label">期望薪资:</span>
              <span class="expectation-value">{{ formatExpectationSalary(expectation) }}</span>
            </div>
          </div>
          
          <div class="expectation-actions">
            <el-button type="text" class="edit-expectation-btn" @click="editJobExpectation(index)">
              <img src="./assets/img/edit.png" class="btn-icon" />
              编辑
            </el-button>
            <el-button type="text" class="delete-expectation-btn" @click="deleteJobExpectation(index)">
              <img src="./assets/img/delete.png" class="btn-icon" />
              删除
            </el-button>
          </div>
        </div>
      </div>
    </div>


    <!-- 添加/编辑求职期望对话框 -->
    <JobExpectationDialog
      :visible.sync="editExpectationDialogVisible"
      :editing-data="currentEditingExpectation"
      @submitted="onExpectationSaved"
      @close="resetExpectationDialog"
    />
  </div>
</template>

<script>
import { getJobTypeLabel } from '@/constants/jobConstants'
import { getUserInfo, getUserExpectList, deleteUserExpect, getUserExpectDetail } from '@/api/user'
import JobExpectationDialog from '@/components/JobExpectationDialog/index.vue'

export default {
  name: 'PersonalBasic',
  components: {
    JobExpectationDialog
  },
  props: {
    userInfo: {
      type: Object,
      default: () => ({
        name: '',
        age: '',
        gender: '',
        phone: '',
        email: '',
        education: '',
        school: '',
        major: ''
      })
    }
  },
  data() {
    return {
      // 个人信息
      personalInfo: {
        name: '',
        age: '',
        gender: '',
        phone: '',
        email: '',
        education: '',
        school: '',
        major: ''
      },
      // 求职期望数据
      jobExpectationData: {
        id: '',
        job_type: '',
        desired_city: '',
        expected_salary_start: '',
        expected_salary_end: '',
        job_objective: ''
      },
      // 求职期望列表
      jobExpectations: [],
      // 对话框控制
      editPersonalDialogVisible: false,
      editExpectationDialogVisible: false,
      editingExpectationIndex: null,
      currentEditingExpectation: null,
      // 编辑模式控制
      isEditing: false,
      // 备份原始数据
      originalPersonalInfo: {}
    };
  },
  created() {
    this.initializePersonalInfo();
    this.loadJobExpectations();
  },
  watch: {
    userInfo: {
      handler(newVal) {
        this.initializePersonalInfo();
      },
      deep: true
    }
  },
  methods: {
    formatExpectationSalary(expectation) {
      const start = expectation && expectation.expected_salary_start
      const end = expectation && expectation.expected_salary_end
      if (start && end) return `${start}k - ${end}k`
      if (start) return `${start}/天`
      return '未填写'
    },
    // 初始化个人信息（从父组件props获取）
    initializePersonalInfo() {
      console.log('子组件接收到的userInfo:', this.userInfo);
      this.personalInfo = {
        name: this.userInfo.name || '',
        age: this.userInfo.age || '',
        gender: this.userInfo.gender || '',
        phone: this.userInfo.phone || '',
        email: this.userInfo.email || '',
        education: this.userInfo.education || '',
        school: this.userInfo.school || '',
        major: this.userInfo.major || ''
      };
      console.log('初始化后的personalInfo:', this.personalInfo);
    },

    // 获取学历文字
    getEducationText(education) {
      if (!education) return '未设置';
      
      const educationMap = {
        '2': '高中',
        '3': '专科', 
        '4': '本科',
        '5': '硕士',
        '6': '博士'
      };
      
      return educationMap[education] || '未设置';
    },

    // 加载用户信息（保留作为备用）
    async loadUserInfo() {
      try {
        const response = await getUserInfo();
        console.log("获取用户信息响应:", response);

        if (response.data.code == 1) {
          const userData = response.data.data;
          console.log("用户信息:", userData);

          // 确保 userData 存在，如果不存在则使用空对象
          const safeUserData = userData || {};

          // 填充表单数据
          this.personalInfo = {
            name: safeUserData.real_name || safeUserData.nickname || '',
            age: safeUserData.age || '',
            gender: safeUserData.sex || '',
            phone: safeUserData.mobile || safeUserData.phone || '',
            email: safeUserData.email || '',
            education: safeUserData.education || '',
            school: safeUserData.school || '',
            major: safeUserData.major || ''
          };
        }
      } catch (error) {
        console.error('获取用户信息失败:', error);
        // 尝试从localStorage获取用户信息
        try {
          const storedUserInfo = localStorage.getItem('userInfo');
          if (storedUserInfo) {
            const userData = JSON.parse(storedUserInfo);
            this.personalInfo = {
              name: userData.name || userData.nickname || '',
              age: userData.age || '',
              gender: userData.sex || '',
              phone: userData.mobile || userData.phone || '',
              email: userData.email || '',
              education: userData.education || '',
              school: userData.school || '',
              major: userData.major || ''
            };
          }
        } catch (e) {
          console.error('从localStorage获取用户信息失败:', e);
        }
      }
    },
    
    // 切换编辑模式
    async toggleEditMode() {
      if (this.isEditing) {
        // 保存模式
        await this.savePersonalInfo();
      } else {
        // 进入编辑模式
        this.originalPersonalInfo = { ...this.personalInfo };
        this.isEditing = true;
      }
    },

    // 取消编辑（如果需要的话）
    cancelEdit() {
      this.personalInfo = { ...this.originalPersonalInfo };
      this.isEditing = false;
      this.originalPersonalInfo = {};
    },

    
    // 保存个人信息
    async savePersonalInfo() {
      try {
        // 准备提交数据
        const submitData = this.personalInfo;
        // 调用父组件的更新方法
        const success = await this.$parent.updateUserInfo(submitData);
        
        if (success) {
          this.editPersonalDialogVisible = false;
          this.isEditing = false;
        }
      } catch (error) {
        console.error("保存个人信息失败:", error);
        this.$message.error("网络错误，请检查网络连接后重试");
      }
    },
  
    
    // 添加求职期望
    addJobExpectation() {
      this.editingExpectationIndex = null;
      this.currentEditingExpectation = null;
      this.editExpectationDialogVisible = true;
    },
    
    // 编辑求职期望
    async editJobExpectation(index) {
      this.editingExpectationIndex = index;
      const displayItem = this.jobExpectations[index];
      
      try {
        // 调用接口获取最新的详情数据
        if (displayItem && displayItem.id) {
          const response = await getUserExpectDetail({ id: displayItem.id });
          if (response.data.code === 1 && response.data.data) {
            const detailData = response.data.data;
            this.currentEditingExpectation = {
              ...detailData,
              desired_city: Array.isArray(detailData.desired_city) 
                ? detailData.desired_city 
                : (detailData.desired_city ? detailData.desired_city.split(',') : [])
            };
          } else {
            this.currentEditingExpectation = displayItem;
          }
        } else {
          this.currentEditingExpectation = displayItem;
        }
      } catch (error) {
        console.warn('获取求职期望详情失败:', error);
        this.currentEditingExpectation = displayItem;
      }
      
      this.editExpectationDialogVisible = true;
    },
    
    // 删除求职期望
    async deleteJobExpectation(index) {
      this.$confirm('确定要删除这个求职期望吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const itemToDelete = this.jobExpectations[index];
          if (itemToDelete && itemToDelete.id) {
            // 调用删除API
            const response = await deleteUserExpect(itemToDelete.id);
            if (response.data.code === 1) {
              this.jobExpectations.splice(index, 1);
              this.$message.success('删除成功');
              // 重新加载数据
              await this.loadJobExpectations();
            } else {
              this.$message.error('删除失败：' + (response.data.msg || '未知错误'));
            }
          } else {
            // 如果没有ID，直接从前端删除
            this.jobExpectations.splice(index, 1);
            this.$message.success('删除成功');
          }
        } catch (error) {
          console.error('删除求职期望失败:', error);
          this.$message.error('删除失败，请重试');
        }
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    
    // 公共组件保存回调，仅刷新列表并关闭
    async onExpectationSaved () {
      await this.loadJobExpectations()
      this.editExpectationDialogVisible = false
      this.currentEditingExpectation = null
      this.editingExpectationIndex = null
    },
    
    // 重置弹框状态
    resetExpectationDialog() {
      this.currentEditingExpectation = null;
      this.editingExpectationIndex = null;
    },

    // 获取求职类型标签
    getJobTypeLabel(jobType) {
      return getJobTypeLabel(jobType);
    },
    

    // 加载求职期望数据
    async loadJobExpectations() {
      try {
        const response = await getUserExpectList();
        if (response.data.code === 1 && response.data.data?.lists) {
          const expectData = response.data?.data?.lists;
          
          this.jobExpectations = expectData;
        }
      } catch (error) {
        console.warn('获取求职期望数据失败:', error);
      }
    },
  }
};
</script>

<style scoped lang="scss">
// 定义颜色变量
$text-color: #656587;

/* 个人详细信息部分 */
.personal-details-section {
  margin-bottom: 40px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.header-buttons {
  display: flex;
  gap: 12px;
  align-items: center;
}

.section-title {
  font-size: 18px;
  font-weight: bold;
  color: $text-color;
  margin: 0;
}

.edit-btn, .add-btn {
  background: transparent;
  border-color: transparent;
  box-shadow: none;
  background: linear-gradient(90deg, #77BAFF 0%, #9C41FF 100%),
              linear-gradient(0deg, rgba(132, 172, 237, 0.4), rgba(132, 172, 237, 0.4));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  padding: 4px 8px;
  font-size: 14px;
  border-radius: 4px;
}

.edit-btn:hover, .add-btn:hover {
  background: transparent;
  border-color: transparent;
  background: linear-gradient(90deg, #77BAFF 0%, #9C41FF 100%),
              linear-gradient(0deg, rgba(132, 172, 237, 0.4), rgba(132, 172, 237, 0.4));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.cancel-btn {
  background: transparent;
  border-color: transparent;
  box-shadow: none;
  color: #909399;
  padding: 4px 8px;
  font-size: 14px;
  border-radius: 4px;
}

.cancel-btn:hover {
  background: transparent;
  border-color: transparent;
  color: #606266;
}

.details-content {
  display: flex;
  gap: 40px;
}

.details-left, .details-right {
  flex: 1;
}

.detail-item {
  display: flex;
  margin-bottom: 16px;
  align-items: center;
}

.detail-label {
  color: $text-color;
  font-size: 14px;
  min-width: 80px;
  margin-right: 8px;
}

.detail-value {
  color: $text-color;
  font-size: 14px;
  flex: 1;
}

.detail-input, .detail-select {
  flex: 1;
  padding: 4px 8px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  color: $text-color;
  background-color: #fff;
  
  &:focus {
    outline: none;
    border-color: #409eff;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
  }
}


/* 求职期望部分 */
.job-expectations-section {
  margin-bottom: 40px;
}

.expectations-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.expectation-card {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.expectation-info {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: space-between; /* evenly distribute items */
  width: 100%;
  white-space: nowrap; /* keep content on one line */
  overflow: hidden; /* clip overflow if too long */
}

.expectation-item {
  display: flex;
  align-items: center;
  white-space: nowrap; /* prevent item wrapping */
  flex: 1 1 0; /* make each item take equal width */
  min-width: 0; /* allow inner text to shrink and ellipsis */
}

.expectation-label {
  color: $text-color;
  font-size: 14px;
  margin-right: 8px;
}

.expectation-value {
  color: $text-color;
  font-size: 14px;
  flex: 1 1 auto; /* fill remaining space within item */
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.expectation-actions {
  display: flex;
  margin-left: 16px;
}

.edit-expectation-btn {
  background: transparent;
  border-color: transparent;
  box-shadow: none;
  background: linear-gradient(90deg, #77BAFF 0%, #9C41FF 100%),
              linear-gradient(0deg, rgba(132, 172, 237, 0.4), rgba(132, 172, 237, 0.4));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  padding: 4px 8px;
  font-size: 14px;
}

.edit-expectation-btn:hover {
  background: linear-gradient(90deg, #77BAFF 0%, #9C41FF 100%),
              linear-gradient(0deg, rgba(132, 172, 237, 0.4), rgba(132, 172, 237, 0.4));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.delete-expectation-btn {
  background: transparent;
  border-color: transparent;
  box-shadow: none;
  color: #F15D5D;
  padding: 4px 8px;
  font-size: 14px;
}

.delete-expectation-btn:hover {
  background: transparent;
  border-color: transparent;
  color: #F15D5D;
}

/* 对话框样式 */
.dialog-footer {
  text-align: right;
}

.dialog-footer .el-button {
  margin-left: 10px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .details-content {
    flex-direction: column;
    gap: 20px;
  }
  
  .expectation-info {
    flex-wrap: wrap; /* allow wrap on small screens */
    white-space: normal;
    gap: 10px 16px;
  }
  
  .expectation-card {
    flex-direction: column;
    gap: 16px;
  }
  
  .expectation-actions {
    margin-left: 0;
    justify-content: flex-end;
  }
}

/* 图标样式 */
.el-icon-edit, .el-icon-plus, .el-icon-delete {
  margin-right: 4px;
}

/* 按钮图标对齐 */
.edit-btn .el-icon-edit,
.add-btn .el-icon-plus {
  vertical-align: middle;
}

/* 自定义按钮图标样式 */
.btn-icon {
  width: 14px;
  height: 14px;
  margin-right: 4px;
  vertical-align: middle;
}

.el-select{
  width: 100%
}

/* 薪资范围输入框样式 */
.row-compact {
  display: flex;
  align-items: center;
  gap: 8px;
  
  .el-input {
    width: 136px; // 让input框更短
  }
}

.dash {
  color: #606266;
  font-weight: 500;
}
</style>